import { type FC } from 'react'
import { getUiOptions, type UiSchema } from '@rjsf/utils'
import { isPlainObject } from '../mergePatch'
import { referenceConfigOf, referenceKindOf } from '../referenceWidgets/registry'
import { childCountSummary, choiceTitleOf, listConfigOf, objectItemsOf, summaryFieldOf } from './arrayModel'

const isBlankValue = (value: unknown): boolean => value === undefined || value === null || (typeof value === 'string' && value.trim() === '')

interface RowSummaryProps {
  arraySchema: unknown
  itemsUiSchema: UiSchema | undefined
  value: unknown
  index: number
  layer: 'account' | 'user'
}

export const RowSummary: FC<RowSummaryProps> = ({ arraySchema, itemsUiSchema, value, index, layer }) => {
  const { itemTitle } = listConfigOf(arraySchema)
  const itemsSchema = objectItemsOf(arraySchema)
  const summaryField = summaryFieldOf(itemsSchema, itemsUiSchema?.['ui:order'])
  const properties = itemsSchema && isPlainObject(itemsSchema.properties) ? itemsSchema.properties : {}
  const fieldSchema = summaryField ? properties[summaryField] : undefined
  const fieldUiSchema = summaryField && itemsUiSchema ? itemsUiSchema[summaryField] : undefined
  const reference = getUiOptions(isPlainObject(fieldUiSchema) ? fieldUiSchema : {}).zocksReference
  const referenceKind = isPlainObject(reference) ? referenceKindOf(reference.kind) : undefined
  const summaryValue = summaryField && isPlainObject(value) ? value[summaryField] : undefined
  const fallback = `${itemTitle} ${index + 1}`
  const childCount = childCountSummary(itemsSchema, value)
  const choiceTitle = choiceTitleOf(fieldSchema, summaryValue)

  return (
    <>
      {choiceTitle !== undefined ? (
        choiceTitle
      ) : isBlankValue(summaryValue) || isPlainObject(summaryValue) || Array.isArray(summaryValue) ? (
        fallback
      ) : referenceKind ? (
        <referenceKind.ValueLabel value={String(summaryValue)} config={referenceConfigOf(reference)} layer={layer} fallback={fallback} />
      ) : (
        String(summaryValue)
      )}
      {childCount ? <span className='fw-normal zocks-text-gray-600'>{` · ${childCount}`}</span> : null}
    </>
  )
}
